import { useQuery } from '@apollo/client';
import { GET_CYBER_FLAG } from './queries';
import { CyberFlag } from './types';

/**
 * A hook that fetches the cyber hub feature flag status from the server.
 * 
 * @returns {{ isEnabled: boolean }} isEnabled - Indicates whether the cyber hub is enabled
 * 
 * @example
 * const { isEnabled } = useCyberFlag();
 * 
 * if (isEnabled) {
 *   // Show cyber hub related features
 * }
 */
const useCyberFlag = (): { isEnabled: boolean; } => {
  const { data } = useQuery<CyberFlag>(GET_CYBER_FLAG);
  const isEnabled = data?.isCyberHubEnabled ?? false;

  return {
    isEnabled,
  };
};

export default useCyberFlag;